import zhLocale from 'element-ui/lib/locale/lang/ru-RU';

import country from './country/ru';
import state from './state/ru';

export default {
  message: {
    title: 'Касса',
    powerByOnerway: 'На базе <span class="ic-powerby"></span>',
    status: {
      loading: 'Загрузка',
    },
    checkout: {
      timeTip:
        'Пожалуйста, завершите платеж в течение  <span class="time">00:{time}</span> минут, иначе страница будет закрыта по тайм-ауту.',
      timeTipsShort: 'стечет через <span class="time">00:{time}</span>',
      billingAddressTip:
        'Расходы будут отображаться в вашем счете как {billingAddress}',
      cardInfo: 'информация о карте',
      cardNumber: 'номер карты',
      prepaidNumber: 'номер карты',
      summary: 'итог заказа',
      expiredDate: 'Срок годности',
      issueDate: 'Issue date',
      cvv: 'CVC/CVV',
      firstName: 'название',
      lastName: 'фамилия',
      holderName: 'Имя владельца карты',
      walletAccountName: 'Имя',
      orderno: 'ID заказа',
      website: 'URL-адрес',
      amount: 'количество',
      pay: 'Платить',
      payNow: 'платить немедленно',
      update: 'Обновить',
      deduction: 'Сумма Списания',
      nextDeductionTime: 'Дата Следующего Списания',
      subscriptionEndTime: 'Дата Окончания Подписки',
      frequency: 'Каждый',
      subscribeTo: 'Подписаться',
      try: 'Попробовать',
      then: 'Затем',
      daysFree: '{X} дней бесплатно',
      forPayments: 'за {X} платеж | за {X} платежей',
      startTrial: 'Начать пробный период',

      week: 'Неделя',
      day: 'День',
      month: 'Месяц',
      year: 'Год',
      cancel: 'Отмена',
      tip: 'намекать',
      cancelPayTip: 'Вы хотите отказаться от этого платежа??',
      yes: 'Да',
      no: 'нет',
      subscription: 'подписка',
      subscribe: 'Подписаться',
      schedule: 'Период оплаты',
      endTime: 'срок',
      subscriptionTip:
        'Подтверждая платеж, вы разрешаете продавцу списывать средства с вашей карты в будущем в соответствии с условиями. ',
      W: 'Неделя',
      D: 'День',
      M: 'Месяц',
      Y: 'Год',
      frequencyData: {
        D: '{time}день/время',
        W: '{time}Неделя/время',
        Y: '{time}Год/время',
        M: '{time}Месяц/время',
      },
      endTimeData: '{year}год{month}Луна{day}Нет',
      billingAddress: 'Платежный адрес/контактная информация',
      country: 'нация',
      province: 'Штат/Провинция/Регион',
      address: 'адрес',
      city: 'Город',
      postalCode: 'Почтовый индекс',
      email: 'Почта',
      phone: 'номер телефона',
      street: 'номер улицы',
      number: 'Номер дома',
      identityNumber: 'налоговый номер',
      intallment: 'Постановка',
      intallmentPlan: 'Рассрочка',
      paymentMethod: 'способ оплаты',
      bankName: 'Название банка',
      iBan: 'Банковский счет',
      contactName: 'Контактное лицо',
      birthDate: 'Дата рождения',
      paymentCompleted: 'Платеж завершен',
      wechatPaymentTip:
        'Пожалуйста, используйте WeChat для сканирования QR-кода для оплаты',
      paymentPending: 'ждать оплаты',
      billingCountry: 'Cтраной плательщика',
      billingCountryTip:
        'Сначала выберите страну выставления счета, чтобы мы могли порекомендовать вам подходящий способ оплаты.',
      nextStep: 'Следующий шаг',
      changeCountryTip:
        'После переключения стран мы порекомендуем вам подходящие способы оплаты.',
      change: 'Изменить',
      scanCode: 'Отсканируй это',
      txnTime: 'Время транзакции',
      moreInfo: 'Дополнительная информация',
      applePayNotSupport: 'Это устройство не поддерживает Apple Pay.',
      policy: {
        prefix: 'Нажимая на кнопку, вы соглашаетесь с ',
        suffix: '',
      },
      privacy: 'Политикой конфиденциальности',
      intallmentTip:
        'Возможно, вам придется выплачивать проценты за рассрочку.',
      payInFull: 'Оплатить полностью',
      payIn: 'Оплата через {count}',
      blikcode: 'Код BLIK',
      unavailable: 'Недоступно',
      notSupportPaymentTips:
        'Способ оплаты в данный момент недоступен. Пожалуйста, вернитесь на страницу выбора.',
      returnText: 'Вернуться к выбору',
      returnMerchant: 'Вернуться на страницу продавца',
      cvvTips:
        'Код CVC находится на обратной стороне вашей карты с правой стороны белой полосы для подписи; это всегда последние 3 цифры для Visa и Mastercard. Для American Express это 4 цифры на лицевой стороне карты.',
      holderNameTips: 'Полное имя на карте',
      continue: 'Продолжить',
      validateCVVTitle: 'Проверка безопасности',
      validateCVVDesc:
        'Для безопасности вашей оплаты, пожалуйста, подтвердите CVC/CVV вашей карты',
      // 订阅产品
      subscriptionProduct: 'Продукт подписки',
      // 订阅费用
      subscriptionFee: 'Плата за подписку',
      // 订阅并支付
      subscriptionAndPay: ' и заплатите',
      // 订阅支付描述-第一行
      subscriptionPaymentLine1: 'Подпишитесь на {productName} и платите',
      // 订阅支付描述-第二行
      subscriptionPaymentLine2: 'каждые {frequency} в течение {duration}, затем {amount} каждые {frequency}',
      // 首次订阅前缀
      firstSubscriptionPrefix: 'за первый ',
      // 然后金额每
      thenAmountPer: 'Затем {amount} {currency} {frequency}',
      // 更新成功
      updateSuccess: 'Обновление успешно',
      // 更新失败
      updateFailed: 'Обновление не удалось',
      // 次
      times: 'Раз',
      free: 'бесплатно',
      details: 'Подробности',
      fold: 'Сложить',
      specialPaymentDivider: 'Или оплатить картой',
      payWithCard: 'Оплатить картой',
      subscriptionNo: 'Подтверждая свою подписку, вы разрешаете снятие средств за будущие платежи в соответствии с условиями. Вы всегда можете отменить свою подписку.',
      subscriptionNo1: 'После окончания пробного периода с вас будет взиматься плата в размере{num}',

      subscriptionFrequency: {
        Y: 'каждые {frequencyPoint} года',
        W: 'каждые{frequencyPoint}недели',
        M: 'каждые {frequencyPoint}месяца',
        D: 'за  {frequencyPoint}день',
      },
      subscriptionFrequencyWithoutPer: {
        Y: '{frequencyPoint} года',
        W: '{frequencyPoint}недели',
        M: '{frequencyPoint}месяца',
        D: '{frequencyPoint}день',
      },
      subscriptionFrequencyStandardized: {
        D_1: 'в день',
        W_1: 'в неделю',
        W_2: 'каждые 2 недели',
        M_1: 'в месяц',
        M_3: 'каждые 3 месяца',
        M_6: 'каждые 6 месяцев',
        Y_1: 'в год',
      },
      subscriptionNo3: 'Вы можете всегда отменить до этого времени',
      saveCardForFasterCheckout: 'Сохранить карту для быстрой оплаты',
      saveCardDesc: 'Безопасно сохранено для будущих покупок на {AppURL}. Удалить в любое время.',
      // Token Payment связанный - Разработчик：Nemo
      useNewCard: 'Добавить карту',
      useSavedCard: 'Использовать сохранённую карту',
      removeCard: 'Удалить карту',
      expired: 'Истёк срок',
      removeCardTitle: 'Удалить эту карту?',
      removeCardDescription: 'Эта карта будет удалена из сохранённых способов оплаты. При необходимости вы сможете добавить её позже.',
      remove: 'Удалить',
      cardRemovedSuccess: 'Карта успешно удалена',
    },
    dlocal: {
      amount: 'сумм',
      expirationDate: 'Крайний срок',
      ticketNumber: 'Ticket номер',
      ticketImage: 'Изображение билета',
      downloadTicket: 'Билет для скачивания',
      searchForShops: 'поиск магазинов',
      fullBoletoView: 'Полный вид болето',
      back: 'назад',
      copySuccess: 'Копировать',
      errorMsg: 'Превышено время ожидания. Не удалось получить параметры.',
      instructionsTitle: 'Инструкция по оплате',
      instructionsContentPIX:
        'ID Инструкции по оплате:<br/>1. Идентификатор транзакции репликации<br/>2. Используйте ID для идентификации платежей PIX в вашем банковском приложении или считайте QR-код в приложении банка.',
      instructionsContentRedpagos:
        'Чтобы совершить платеж, вам нужно будет прийти в магазин Redpagos.<br/>Назвав номер своей идентификационной карты и уточнив, что вы хотите оплатить счет dlocal, вы сможете совершить платеж.',
      instructionsContentOXXO:
        '1. Отправляйтесь в ближайший магазин oxxo.<br/>2. Укажите в поле, что вы хотите совершить платеж oxxopay.<br/>3. Продиктуйте номер карты кассиру для ввода.<br/>непосредственно на экране продаж.<br/>4. Произведите соответствующий платеж наличными.<br/>5. Когда вы подтвердите оплату, кассир выдаст вам распечатанный ваучер. Здесь вы можете убедиться, что все было сделано правильно. Сохраните это доказательство оплаты.<br/>6. Для получения дополнительной информации о вашем платеже посетите наш справочный центр',
      instructionsContentSPEI:
        '1. Немедленная аккредитация.<br/>2. После получения банковского перевода dlocal сообщит о доставке приобретаемого продукта/услуги.<br/>3. Если у вас возникли проблемы с оплатой, пожалуйста, посетите наш портал обслуживания клиентов.',
      instructionsContentSencillito:
        'Платежная инструкция лично:<br/>В офисе Sencillito вы можете произвести оплату, указав номер и указав, что хотите оплатить счет-фактуру DLOCAL.<br/>Платежная инструкция онлайн:<br/>Для оплаты необходимо зайти на портал Sencillito, выбрать "dlocal"в поисковой системе компании и ввести код, указанный на ваучере 134216.',
      instructionsContentServipag:
        'Primero díctale al cajero el código de servicio:<br/>Si es YoPag: "company_id"<br/>Si es por caja:"company_id2"',
      bankDetailsTitle: 'Банковские реквизиты',
      bankDetailsSPEI:
        'Войдите в систему и переведите деньги на следующий счет. Обратите внимание, что оплата наличными не возможна.<br/>Банк назначения:<span class="detail-value">{bank}</span><br/Телефон: <span class="detail-value">{clabe}</span><br/>Бенефициар: <span class="detail-value">{beneficiary}</span><br/>Сумма: <span class="detail-value">{amount} {currency}</span><br/>Концепция оплаты: <span class="detail-value">{concept}</span><br/>Справочный документ: <span class="detail-value">{reference}</span>',
      paymentTypeTitle: 'Тип оплаты',
      paymentTypeServipag:
        'Por favor, indique al cajero el código de servicio<br/>Si es Empresa_1: <span class="company">{company1}</span><br/>Si se Empresa_2: <span class="company">{company2}</span>',
    },
    palmpay: {
      amount: 'Сумма',
      orderTips: 'Пожалуйста, переведите на следующий счет',
      numberTitle: 'Номер счета (только для этой транзакции)',
      copyBtnText: 'Скопировать номер счета',
      expireText: 'Заказ истекает через {time}',
      bankName: 'Название банка',
    },
    date: {
      month: {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        10: '10',
        11: '11',
        12: '12',
      },
    },
    result: {
      success: 'Оплата успешно завершена',
      failed: 'Платеж не прошел',
      unknow: 'Платежи',
      unknowTip:
        'Пожалуйста, обновите статус заказа, чтобы проверить результат платежа',
      jump: 'Возвращение к продавцу через <span class="hightlight">{time}s</span>',
      reason: 'причина',
      processing: 'Обработка...',
      processingTitle: 'Обработка',
      processingDescription: 'Транзакция обрабатывается, пожалуйста, подождите.',
      processingButtonText: 'Подтвердить',
      paymentStatusCheckText1: 'Оплата прошла успешно, но страница не обновилась?',
      paymentStatusCheckText2: 'Нажмите здесь, чтобы проверить статус транзакции.',
      timeout: 'Время ожидания страницы истекло, повторите платеж',
      invalid: 'Неверный запрос на транзакцию',
      cancelled: 'Заявка на оплату была отменена, пожалуйста, не платите снова',
      emptyPaymentMethod: 'Для этой страны не настроены способы оплаты.',
      error:
        'Ошибка. Пожалуйста, проверьте результат транзакции на странице заказа торгового сайта.',
      successPop: 'Вы можете вернуться в магазин, чтобы просмотреть информацию о заказе.',
      autoRedirectCountdown: 'Автоматический переход на страницу продавца через {seconds}с',
    },
    validator: {
      input: 'Пожалуйста, введите допустимый {field}',
      intallmentCardOrCountryNotSupport:
        'Оплата в рассрочку не поддерживается типом карты или страной',
      required: 'Требуется',
    },
    error: {
      timeout: 'Ошибка сети, повторите попытку позже',
      cardNumber: 'Информация о карте неверна',
      retyrTitle: 'Платёж не прошёл, пожалуйста, попробуйте снова.',
      brokenLinkMessage: 'Эта платежная ссылка может быть повреждена, просрочена или ваш платежный запрос все еще обрабатывается.',
      contactMerchantMessage: 'Пожалуйста, свяжитесь с продавцом, если у вас есть какие-либо вопросы.',
      errorTitle: 'Ой!',
      paymentLinkExpired: 'Срок действия ссылки на оплату истек',
    },
    country,
    state,
    QR: {
      amount: 'Сумма',
      details: 'Детали',
      paymentMethod: 'Способ оплаты',
      validUntil: 'Действителен до',
      scanQrCode: 'Отсканируйте QR-код для оплаты',
      validFor24h: 'Действителен в течение 24ч',
      orderId: 'Номер заказа',
      website: 'Веб-сайт',
      scanQrCodeOrDownload: 'Отсканируйте QR-код или нажмите "Скачать QR", чтобы сохранить и отсканировать в своем приложении для оплаты',
      downloadQr: 'Скачать QR',
      orderDetails: 'Детали заказа',
    },
  },
  ...zhLocale,
};
